import { QUESTIONS, createReader } from './documentData'
import { GUIDE_QUESTIONS, formatCompletionDate, sortNumerically } from './guideData'

// Perguntas usadas só na Notificação de Fumigação
const NOTICE_QUESTIONS = {
  holds: 196, // filha ("PORÕES A SEREM TRATADOS"); se estiver vazia, vale a 1001
  fallbackHolds: GUIDE_QUESTIONS.holds,
  // horas de exposição: perguntas alternativas (uma por lógica); vale a primeira respondida
  exposureTimes: GUIDE_QUESTIONS.exposureTimes.slice(0, 3)
}

const HOURS_PER_DAY = 24

// 192 horas -> "8" dias; arredonda para cima quando não é inteiro
export const toDays = hours => (hours > 0 ? String(Math.ceil(hours / HOURS_PER_DAY)) : '')

export const buildNoticeData = ({ serviceOrder, childrenServiceOrders = [], assets = [] }) => {
  const { answer } = createReader({ serviceOrder, childrenServiceOrders, assets })

  const hours = Number(NOTICE_QUESTIONS.exposureTimes.map(answer).find(Boolean))
  const completionDate = formatCompletionDate(serviceOrder.endDate)

  return {
    activityCode: serviceOrder.yearlyId || '',
    ship: answer(QUESTIONS.ship).toUpperCase(),
    holds: sortNumerically(answer(NOTICE_QUESTIONS.holds) || answer(NOTICE_QUESTIONS.fallbackHolds)),
    days: toDays(hours),
    dateEn: completionDate.en,
    datePt: completionDate.pt
  }
}
